interface CalculateNextValueProps {
  current: number;
  max: number;
  min: number;
  step: number;
}

export function calculateNextValue() {
  let countUp = true;

  function count({ current, max, min, step }: CalculateNextValueProps) {
    if (countUp && current + step <= max) {
      countUp = true;
      return current + step;
    }

    if (current - step < min) {
      countUp = true;
      return current + step;
    }
    countUp = false;
    return current - step;
  }
  return count;
}
